/**
 * KrutiKala Explore India — hotspot hover / focus / click-to-pin
 * Figma Make: src/components/ExploreIndia.tsx
 */
class KKExploreIndia extends HTMLElement {
  connectedCallback() {
    this.map = this.querySelector('[data-kk-india-map]');
    this.panel = this.querySelector('[data-kk-india-panel]');
    this.hotspots = Array.from(this.querySelectorAll('[data-kk-region]'));
    this.activeId = null;
    this.pinned = null;

    this.hotspots.forEach((btn) => {
      btn.addEventListener('mouseenter', () => this.show(btn));
      btn.addEventListener('focus', () => this.show(btn));
      btn.addEventListener('click', (event) => {
        event.preventDefault();
        this.pin(btn);
        if (this.isCompact() && this.panel) {
          this.panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      });
    });

    if (this.isCompact() && this.hotspots[0]) this.pin(this.hotspots[0]);

    if (this.map) {
      this.map.addEventListener('mouseleave', () => this.restore());
    }

    this.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        this.unpin();
        this.hide();
      }
    });
  }

  isCompact() {
    return window.matchMedia('(max-width: 1023px)').matches;
  }

  pin(btn) {
    if (this.pinned) this.pinned.classList.remove('is-pinned');
    this.pinned = btn;
    btn.classList.add('is-pinned');
    this.show(btn);
  }

  unpin() {
    if (this.pinned) this.pinned.classList.remove('is-pinned');
    this.pinned = null;
  }

  restore() {
    if (this.pinned) this.show(this.pinned);
    else this.hide();
  }

  show(btn) {
    const id = btn.getAttribute('data-kk-region');
    if (!id || id === this.activeId) return;
    this.activeId = id;

    this.hotspots.forEach((h) => {
      const on = h === btn;
      h.classList.toggle('is-active', on);
      h.setAttribute('aria-expanded', on ? 'true' : 'false');
    });

    const cards = this.querySelectorAll('[data-kk-region-card]');
    cards.forEach((card) => {
      const match = card.getAttribute('data-kk-region-card') === id;
      card.hidden = !match;
      card.classList.toggle('is-visible', match);
    });

    if (this.panel) this.panel.classList.add('is-visible');
  }

  hide() {
    this.activeId = null;
    this.hotspots.forEach((h) => {
      h.classList.remove('is-active');
      h.setAttribute('aria-expanded', 'false');
    });
    this.querySelectorAll('[data-kk-region-card]').forEach((card) => {
      card.hidden = true;
      card.classList.remove('is-visible');
    });
    if (this.panel) this.panel.classList.remove('is-visible');
  }
}

if (!customElements.get('kk-explore-india')) {
  customElements.define('kk-explore-india', KKExploreIndia);
}
